<template>
	<div class="app">
		<router-view></router-view>
		<LoginModal />
	</div>
</template>

<script>
import LoginModal from './components/organisms/LoginModal'

export default {
	name: 'App',
	data() {
		return {
			val: 0,
			showModal: true
		}
	},
	
	components: {
		LoginModal
	},
	watch: {
		// Hide overflow to prevent scroll on trasition
    $route() {
				document.getElementsByClassName("app")[0].style.overflow = "hidden";
		}
	},
	// Show overflow after transition
	updated: function () {
    setTimeout(function () {
        document.getElementsByClassName("app")[0].style.overflow = "inherit";
    }, 500);
	},
	methods: {}
}
</script>

<style lang="scss">
@import './main.scss';
.app {
	padding-top: 0;
	margin-bottom: 0;
	position: relative;
}
.navbar-controls .languages.dropdown {
	@include for-phone-only {
		display: none !important;
	}
}
</style>
